module.exports = __webpack_public_path__ + "86a88f7248842d654a424348ba6caef1.png";